import { t } from 'i18next';
import logo from '../../../assets/logo.png';
import type { I18nPrefix } from '../../../i18n/prefix';

const PAGE = 'features:auth.pages.common' satisfies I18nPrefix;

type AuthLogoProps = {
  className?: string;
};

export function AuthLogo({ className = 'h-9 w-auto' }: AuthLogoProps) {
  return <img className={className} src={logo} alt={t(`${PAGE}.logo_alt`)} />;
}
